<template lang="pug">
v-container
  v-row
    v-col(cols="12")
      h1 Все пользователи
    v-col(cols="12")
      v-card(outlined).pt-2
        smart-table(
          :headers="headers"
          :adapter="adapter"
          :needToUpdateTable="needToUpdateTable"
        )
          template(#header)
            v-btn.mr-2(@click="dialog = true" color="success")
              v-icon(left) mdi-plus
              | Добавить
          template(#search--role="{ searchKeys, runSearch }")
            select-role(
              v-model="searchKeys.role"
              dense
              outlined
              prepend-inner-icon="mdi-magnify"
              label='Роль'
              hide-details
              clearable
              @keyup.enter="runSearch"
              @change="runSearch"
            )
          template(#search--region_id="{ searchKeys, runSearch }")
            select-region(
              v-model="searchKeys.region_id"
              dense
              outlined
              prepend-inner-icon="mdi-magnify"
              label='Регион'
              hide-details
              clearable
              @keyup.enter="runSearch"
              @change="runSearch"
            )
          template(#search--municipality_id="{ searchKeys, runSearch }")
            select-mun(
              v-model="searchKeys.municipality_id"
              dense
              outlined
              prepend-inner-icon="mdi-magnify"
              label='Муниципалитет'
              hide-details
              clearable
              @keyup.enter="runSearch"
              @change="runSearch"
            )
          template(#value--email="{ item }")
            template(v-if="item.profile.email || (item.email_setting && item.email_setting.username)") {{ item.profile.email  || item.email_setting.username || ''}}
            v-chip(v-else label color="error") Почта не указана
          template(#value--role="{ item }")
            v-chip(color="primary" label) {{ ROLES_NAMES[item.roles[0]] }}
          template(#value--region_id="{ item }")
            v-chip(v-if="item.region_id" label)
              span {{ cachedRegion(item.region_id).name }}
            template(label text v-else) -

          template(#value--municipality_id="{ item }")
            v-chip(v-if="item.municipality_id" label)
              span {{ cachedMunicipality(item.municipality_id).name }}
            template(label text v-else) -
          template(#value--email_setting="{ item }")
            template(v-if="item.email_setting")
              v-icon(color="success") mdi-check
            template(v-else)
              v-icon mdi-minus
          template(#value--projects="{ item }")
              add-project-chips(
                :projects="item.projects || []"
                @delete="deleteUserProject({project_id: $event, user_id: item.id })"
                @open="openAddProject(item)"
              )
                //- :show-actions="!Boolean(item.parent_id)"
          template(#value--action='{ item }')
            .d-flex
              v-tooltip(bottom) Настройки
                template(#activator="{ on }")
                  v-btn.mr-2.rounded(
                    :disabled="!item.parent_id || isAdmin"
                    v-on="on"
                    @click="$router.push('/users/' + item.id)"
                    fab
                    tile
                    x-small
                    color="primary"
                  )
                    v-icon mdi-wrench
              v-tooltip(bottom)
                template(#activator="{ on , attrs}")
                  v-btn.mr-2.rounded(
                    v-bind="attrs"
                    v-on="on"
                    :color="item.status === USER_STATUS.ACTIVE ? 'accent ': 'error'"
                    @click="changeUserStatus(item)"
                    fab
                    tile
                    x-small
                  )
                    v-icon
                      | mdi-lock-outline
                span {{ item.status === USER_STATUS.ACTIVE ? 'Заблокировать' : 'Разблокировать' }}
              v-btn.rounded(color="error" @click="deleteUser(item.id)" fab tile x-small)
                v-icon
                  | mdi-trash-can
  v-dialog(v-model='dialogAddProject' dark max-width='500px')
    v-card.pa-5
      p.text-h5 Добавление проекта
      select-project(
        v-model="formProject.project_id"
        :selectable="selectableRoles"
        filled
        clearable
      )
      v-btn.mr-4(
        :disabled="!formProject.project_id"
        color="success"
        @click="addUserProject"
      ) Сохранить
      v-btn(text @click='dialogAddProject = false') Отменить

  v-dialog(v-model='dialog' max-width='500px' dark)
    v-card.pa-5
      // pre {{projectRoles}}
      v-form(ref="form" v-model="valid")
        p.text-h5 {{ title }}
        v-text-field(
          required
          :rules="[rules.required, rules.min(6)]"
          v-model="form.username"
          filled
          label='Логин'
        )

        template(v-if="!form.id")
          v-text-field(
            :rules="[rules.required, rules.min(6)]"
            v-model="form.password"
            required
            filled
            label="Пароль"
            type="password"
          )

          v-text-field(
            :rules="[rules.required, rules.min(6)]"
            required
            v-model="form.password_confirmation"
            filled
            label='Подтверждение пароля'
            type="password"
          )

        select-role(
          v-if="isAdmin"
          :rules="[rules.required]"
          required
          v-model="form.role"
          :selectable="selectableRoles"
          filled
          label='Роль'
        )

        select-region(
          v-model="form.region_id"
          :disabled="!form.role || isRegion"
          :rules="[rules.required]"
          :query="isSupport && { 'search[is_free]': 1 }"
          filled
          label='Регион'
          required
        )

        select-mun(
          v-if="isMunicipality || isAdmin || isRegion && form.role === ROLES.municipality"
          :query="isRegion && { 'search[is_free]': 1 }"
          v-model="form.municipality_id"
          filled
          label='Муниципалитет'
          :rules="[rules.required]"
          :region="form.region_id"
          :disabled="!form.region_id"
        )

        select-project(
          v-model="form.project_ids"
          @change="checkDeletedRoles"
          filled
          multiple
        )
        select-project-role(
          filled
          multiple
          v-for="project in form.project_ids"
          :key="project"
          v-model="form.project_roles"
          :label="labelForProjectRole(project)"
          :projectId="project"
        )
        v-btn.mr-4(
          :disabled="!valid"
          :loading="loadingSubmit"
          color="success"
          @click="submit"
        ) Сохранить
        v-btn(text @click='dialog = false') Отменить
  confirm-form-dialog(
    v-model="deleteUserDialog"
    @accept="acceptDeleteUser"
    message="Действительно удалить пользователя?"
  )

  confirm-form-dialog(
    v-model="changeUserDialog"
    @accept="acceptChangeStatus"
    message="Действительно выполнить действие?"
  )
</template>

<script>
/* eslint-disable no-unused-expressions */
import SmartTable from '@/components/SmartTable/index.vue';
import userService, { CRUDUsers } from '@/services/API/user';
import SelectRole from '@/components/inputs/SelectRole.vue';
import SelectRegion from '@/components/inputs/SelectRegion.vue';
import SelectMun from '@/components/inputs/SelectMun.vue';
import rules from '@/lib/rules';
import { ROLES, ROLES_NAMES } from '@/constants';
import ConfirmFormDialog from '@/components/dialogs/ConfirmFormDialog.vue';
import AddProjectChips from '@/components/AddProject/AddProjectChips.vue';
import projectService from '@/services/API/project';
import SelectProject from '@/components/inputs/SelectProject.vue';
import SelectProjectRole from '@/components/inputs/SelectProjectRole.vue';
import { mapActions, mapGetters } from 'vuex';
import checkRole from '@/lib/checkRole';
import { CACHE_KEYS } from '@/store/modules/cache';
import { USER_STATUS, ACTION_LIST } from '../constants';

const DEFAULT_FORM = {
  username: '',
  password: '',
  password_confirmation: '',
  role: '',
  municipality_id: null,
  project_ids: [],
  project_roles: [],
};

export default {
  components: {
    SmartTable,
    SelectRole,
    SelectRegion,
    SelectMun,
    ConfirmFormDialog,
    AddProjectChips,
    SelectProject,
    SelectProjectRole,
  },

  data() {
    return {
      updateTable: null,
      needToUpdateTable: false,

      loadingSubmit: false,
      dialog: false,
      form: { ...DEFAULT_FORM },
      valid: false,
      rules,

      dialogAddProject: false,
      projectAddInfo: null,
      formProject: {
        project_id: null,
      },

      deleteUserDialog: false,
      deleteUserId: null,

      changeUser: null,
      changeUserDialog: false,

      ROLES,
      ROLES_NAMES,
      USER_STATUS,
      ACTION_LIST,
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/getUser',
      userRole: 'auth/userRole',
      isSupport: 'auth/isSupport',
      isRegion: 'auth/isRegion',
      isAdmin: 'auth/isAdmin',
      isMunicipality: 'auth/isMunicipality',
      cachedMunicipality: 'cache/cachedMunicipality',
      cachedRegion: 'cache/cachedRegion',
      cachedProject: 'cache/cachedProject',
      cachedProjects: 'cache/cachedProjects',
    }),
    headers() {
      const headers = [
        {
          text: 'Логин',
          align: 'start',
          value: 'username',
          searchable: true,
        },
        { text: 'Email', value: 'email', searchable: true },
        { text: 'Муниципалитет', value: 'municipality_id', searchable: true },
        { text: 'Проекты', value: 'projects' },
        { text: 'Действия', value: 'action' },
      ];

      if (checkRole(this.userRole, [ROLES.admin, ROLES.support])) {
        headers.unshift({
          text: 'Регион',
          value: 'region_id',
          searchable: true,
        });
      }
      if (!checkRole(this.userRole, [ROLES.municipality])) {
        headers.push({ text: 'Роль', value: 'role', searchable: true });
      }
      if (checkRole(this.userRole, [ROLES.region])) {
        headers.push({ text: 'Настроена почта', value: 'email_setting' });
      }

      return headers;
    },

    title() {
      return this.form.id
        ? 'Редактирование пользователя'
        : 'Новый пользователь';
    },

    selectableRoles() {
      if (checkRole(this.userRole, ROLES.admin)) {
        return [ROLES.support];
      }

      if (this.isSupport) {
        return [ROLES.region];
      }

      if (this.isRegion) {
        return [ROLES.municipality, ROLES.region];
      }

      if (checkRole(this.userRole, ROLES.municipality)) {
        return [ROLES.municipality];
      }

      return [];
    },
  },

  watch: {
    dialog(val) {
      if (!val) this.close();

      if (this.isRegion) {
        this.form.region_id = this.user.region_id;
      }
    },
  },

  methods: {
    ...mapActions({
      loadToCache: 'cache/loadToCache',
    }),

    async adapter({ _update, ...options }) {
      this.updateTable = _update;
      this.needToUpdateTable = false;

      const params = {
        ...options,
        'expand': 'region_id,municipality_id,parent,projects,email_setting',
        'sort': '-id',
        'search[parent_id]': this.isAdmin ? null : this.user.id,
      };
      const response = await CRUDUsers.getAll(params);

      const municipality_ids = response.data.data.map(
        ({ municipality_id }) => municipality_id,
      );
      await this.loadToCache({
        key: CACHE_KEYS.municipalities,
        ids: municipality_ids,
      });

      const region_ids = response.data.data.map(({ region_id }) => region_id);
      await this.loadToCache({ key: CACHE_KEYS.regions, ids: region_ids });

      return new Promise((resolve) => resolve(response));
    },
    labelForProjectRole(project) {
      return `Выберите роль для ${this.cachedProject(project).name}`;
    },
    async submit() {
      this.loadingSubmit = true;
      const params = {
        ...this.form,
      };

      if (params.role === ROLES.region) {
        delete params.municipality_id;
      }

      try {
        if (this.form.id) {
          delete params.password;
          delete params.password_confirmation;
          params.name = params.username;
          await userService.updateProfile(this.form.id, params);
        } else {
          params.parent_id = this.user.id;
          await CRUDUsers.create(params);
          this.$toast.success('Пользователь был создан');
          this.needToUpdateTable = true;
        }
        this.close();
      } catch (error) {
        this.$toast.error(error.response.data.data.messsage);
      } finally {
        this.loadingSubmit = false;
      }
    },
    checkDeletedRoles() {
      // console.log(this.cachedProjects);
    },
    async deleteUserProject({ project_id, user_id }) {
      const params = {
        user_ids: [user_id],
      };
      await projectService.detachUser(project_id, params);
      this.updateTable((items) => {
        const index = items.findIndex(({ id }) => id === user_id);
        items[index].projects = items[index].projects.filter(
          ({ id }) => id !== project_id,
        );
        return items;
      });
    },

    changeUserStatus(user) {
      this.changeUser = user;
      this.changeUserDialog = true;
    },

    async acceptChangeStatus() {
      const { id, status } = this.changeUser;
      try {
        if (status === USER_STATUS.ACTIVE) {
          await userService.block(id);
        } else {
          await userService.block(id);
        }
        this.$toast.success('Статус успешно сменен');
        this.updateTable((items) => {
          const index = items.findIndex(({ id: user_id }) => id === user_id);
          items[index].status =            USER_STATUS.ACTIVE === status
            ? USER_STATUS.CLOSED
            : USER_STATUS.ACTIVE;
          return items;
        });
      } catch (error) {
        this.$toast.error('Не удалось поменять статус');
      }
    },

    openAddProject(data) {
      this.projectAddInfo = data;
      this.dialogAddProject = true;
    },

    async addUserProject() {
      const { id } = this.projectAddInfo;
      const params = {
        user_ids: [id],
      };
      const { project_id } = this.formProject;
      try {
        await projectService.attachUser(project_id, params);
        await this.loadToCache({ key: CACHE_KEYS.projects, ids: [project_id] });

        this.updateTable((items) => {
          const index = items.findIndex(({ id: user_id }) => id === user_id);
          items[index].projects.push(this.cachedProject(project_id));
        });
        this.dialogAddProject = false;
        this.projectAddInfo = null;
      } catch (error) {
        this.$toast.error('Проект уже существует');
      }
    },

    deleteUser(id) {
      this.deleteUserDialog = true;
      this.deleteUserId = id;
    },

    async acceptDeleteUser() {
      this.deleteUserDialog = true;
      await CRUDUsers.delete(this.deleteUserId);
    },

    close() {
      this.dialog = false;
      this.form = { ...DEFAULT_FORM };
    },
  },
};
</script>

<style></style>
